import { fetchAll } from './fetch';

export default fetchAll('families', { resourceName: 'family' });
